import { Box, Container } from "@mui/material";
import { styled } from "@mui/material/styles";
import Logo from "src/components/Logo";
import Page from "src/components/Page";
import useLocales from "src/hooks/useLocales";

import Context from "./context";
import SendedEmailInfo from "./SendedEmailInfo";
import SendEmailSection from "./SendEmailSection";
import useRestorePasswordStore from "./store";
// ----------------------------------------------------------------------

const RootStyle = styled("div")(({ theme }) => ({
	display: "flex",
	minHeight: "100%",
	alignItems: "center",
	justifyContent: "center",
	padding: theme.spacing(12, 5)
}));

// ----------------------------------------------------------------------

export default function ResetPassword() {
	const [state, actions] = useRestorePasswordStore();

	const { translate } = useLocales();

	return (
		<Page title={translate("Reset Password")}>
			<RootStyle>
				<Logo sx={{ position: "absolute", top: 0, mt: 5 }} />
				<Container>
					<Context.Provider value={{ state, actions }}>
						<Box sx={{ maxWidth: 480, mx: "auto" }}>
							{!state.isSended ? <SendEmailSection /> : <SendedEmailInfo />}
						</Box>
					</Context.Provider>
				</Container>
			</RootStyle>
		</Page>
	);
}
